import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import {Modal, Button} from 'react-bootstrap'

import TabContainer from '../TabContainer'

import List from './list/List'
import UserGroup from './user-group/UserGroup'

import { fetchApi } from '../../api/fetchApi';
import { listUserGroupsApi } from '../../api/userGroupApi';
import { deleteUserGroupOfCompany } from '../../api/companyApi';

const UserGroupsAdministration = ({height, company}) => {

  const [userGroupList, setGroupUserList] = useState([])
  const [userGroupSelected, setUserGroupSelected] = useState(null);

  const [objectToDelete, setObjectToDelete] = useState({})

  useEffect(() => {
    if(company.id){
      reloadUserGroupList()
    }
  }, [company.id])

  const reloadUserGroupList = () => {    
    listUserGroupsApi(company.id)
    .then(response => {      
        setGroupUserList(response.data);
    })
    .catch(error => {
      console.log('ERROR RELOAD GROUPS: ', error.response);
    })
  }

  const confirmDeleteObject = (objectToDelete) => {
    setObjectToDelete(objectToDelete);
    
  };




  const selectUserGroup = (userGroup) => {
    setUserGroupSelected(userGroup);
  };

  const newUserGroup = () => {
    setUserGroupSelected({})
  }

  const cancelEdition = () => {
    setUserGroupSelected(null);
  }

  const deleteUserGroup = () => {
    deleteUserGroupOfCompany(company.id, objectToDelete.id)
    .then((response) => {
        setObjectToDelete({});
        reloadUserGroupList();
    });
  }

    return (
        <TabContainer height={height}>
            <AdmMainContainer>
            {
              objectToDelete.id ? 
              <DeleteModal 
              show={true} 
              onHide={null}
              cancel={confirmDeleteObject}
              remove={deleteUserGroup}/> 
              
              :null
            }
              {userGroupSelected ?
               <UserGroup 
                userGroup={userGroupSelected}
                company={company}
                selectUserGroup={selectUserGroup}
                reloadUserGroupList={reloadUserGroupList}
               />
                :
                <List 
                company={company}
                items={userGroupList.filter((group) => {return group.id != company.memberGroupId})}
                selectUserGroup={selectUserGroup}
                newUserGroup={newUserGroup}
                deleteObject={confirmDeleteObject}/>
              }
            </AdmMainContainer>
        </TabContainer>
    )


}

const AdmMainContainer = styled.div`
    display:flex;

`

export default UserGroupsAdministration;


const DeleteModal = ({show, onHide, content, cancel,remove}) => {

 

  const DeleteModal = styled.div`
    .title-message{
      font-size: 1.8rem; 
      color:#d90000;
      font-weight:900;
    }

    .important-message{
      font-size: 1.6rem; 
      color:#d90000;
      font-weight:900;
      padding:20px;
    }

    .normal-text{
      font-size: 1.5rem ; 
      
    }

    .danger-button{
      background-color:#d90000;
      color:white;


    }


  `

  return (
    
      <Modal show={show} onHide={() => cancel({})}>
        <DeleteModal>
        <Modal.Header closeButton>
            
          <Modal.Title><div className="title-message"> <i class="fas fa-exclamation-circle"/> Attention!</div></Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="normal-text">
          Are you sure you want remove this user group?
        </div>
        <div className="important-message">
          This action cannot be undone.
        </div>

        </Modal.Body>
        <Modal.Footer>
          <Button className="danger-button" variant="danger" onClick={() => {remove()}}>
            Remove
          </Button>
          <Button onClick={() => {cancel({})}}>
            Cancel
          </Button>
        </Modal.Footer>
        </DeleteModal>
      </Modal>
  )

  
}
